module.exports = __webpack_public_path__ + "img/money.94fc4f44.svg";